import { IMAGE_MIME_TYPES } from 'pages/Batch/configs';

const getWebpSupport = () => {
  const canvas = document.createElement('canvas');
  return !!canvas.getContext?.('2d') && canvas.toDataURL('image/webp').startsWith(`data:${IMAGE_MIME_TYPES.WEBP}`);
};

export default getWebpSupport;
